import { Link } from 'react-router-dom';
import { appConfig } from "../../apiConfig";
import { useLanguage } from "../../context/LanguageProvider";

export default function Footer() {
  const { t } = useLanguage();
  return (
    <footer className="bg-white text-black" dir="rtl">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-16 lg:py-20">
          <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-12">
            {/* Logo and Description */}
            <div className="lg:col-span-2">
              <Link to="/" className="inline-block group">
              <img src={`/images/${appConfig.slug}-logo.png`} height={90} width={170} alt="logo" />
              </Link>
              <p className="mt-6 text-gray-600  leading-relaxed max-w-md">
                {t('footer.description')}
              </p>
              <div className="mt-8 flex space-x-5">
              </div>
            </div>

            <div>
              <h3 className="text-xs max-md:mt-20 font-bold text-black tracking-wider uppercase mb-6">{t('footer.platform')}</h3>
              <ul className="space-y-4 text-xs">
                <li><Link to="/" className="text-gray-600 hover:text-[var(--color-primary-500)] transition-colors duration-300">{t('footer.platform_home')}</Link></li>
                <li><Link to="/about" className="text-gray-600 hover:text-[var(--color-primary-500)] transition-colors duration-300">{t('footer.platform_about')}</Link></li>
                <li><Link to="/contact" className="text-gray-600 hover:text-[var(--color-primary-500)] transition-colors duration-300">{t('footer.platform_contact')}</Link></li>
                <li><Link to="/affiliate-program" className="text-gray-600 hover:text-[var(--color-primary-500)] transition-colors duration-300">{t('footer.platform_affiliate')}</Link></li>
              </ul>
            </div>

            <div>
              <h3 className="text-xs font-bold text-black tracking-wider uppercase mb-6">{t('footer.resources')}</h3>
              <ul className="space-y-4 text-xs">
                <li><Link to="/help" className="text-gray-600 hover:text-[var(--color-primary-500)] transition-colors duration-300">{t('footer.resources_help')}</Link></li>
                <li><Link to="/blog" className="text-gray-600 hover:text-[var(--color-primary-500)] transition-colors duration-300">{t('footer.resources_blog')}</Link></li>
                <li><Link to="/tutorials" className="text-gray-600 hover:text-[var(--color-primary-500)] transition-colors duration-300">{t('footer.resources_tutorials')}</Link></li>
                <li><Link to="/case-studies" className="text-gray-600 hover:text-[var(--color-primary-500)] transition-colors duration-300">{t('footer.resources_case_studies')}</Link></li>
                <li><Link to="/api" className="text-gray-600 hover:text-[var(--color-primary-500)] transition-colors duration-300">{t('footer.resources_api')}</Link></li>
              </ul>
            </div>

            <div>
              <h3 className="text-xs font-bold text-black tracking-wider uppercase mb-6">{t('footer.legal')}</h3>
              <ul className="space-y-4 text-xs">
                <li><Link to="/policy" className="text-gray-600 hover:text-[var(--color-primary-500)] transition-colors duration-300">{t('footer.legal_privacy')}</Link></li>
                <li><Link to="/terms" className="text-gray-600 hover:text-[var(--color-primary-500)] transition-colors duration-300">{t('footer.legal_terms')}</Link></li>
                <li><Link to="/cookies" className="text-gray-600 hover:text-[var(--color-primary-500)] transition-colors duration-300">{t('footer.legal_cookies')}</Link></li>
                <li><Link to="/gdpr" className="text-gray-600 hover:text-[var(--color-primary-500)] transition-colors duration-300">{t('footer.legal_gdpr')}</Link></li>
                <li><Link to="/affiliate-disclosure" className="text-gray-600 hover:text-[var(--color-primary-500)] transition-colors duration-300">{t('footer.legal_affiliate_disclosure')}</Link></li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Bar - Remain in English as requested */}
        <div className="border-t border-gray-200 py-8 text-xs" dir="ltr">
          <div className="flex flex-col lg:flex-row justify-between items-center space-y-4 lg:space-y-0">
              <p className="text-gray-600 text-center lg:text-left">
              {t('footer.bottom_rights', { year: new Date().getFullYear(), name: appConfig.name })}
            </p>
            <div className="flex flex-wrap justify-center lg:justify-end space-x-6">
              <Link to="/policy" className="text-sm text-gray-600 hover:text-[var(--color-primary-500)] transition-colors duration-300">{t('footer.bottom_privacy')}</Link>
              <Link to="/terms" className="text-sm text-gray-600 hover:text-[var(--color-primary-500)] transition-colors duration-300">{t('footer.bottom_terms')}</Link>
              <Link to="/cookies" className="text-sm text-gray-600 hover:text-[var(--color-primary-500)] transition-colors duration-300">{t('footer.bottom_cookies')}</Link>
              <Link to="/sitemap" className="text-sm text-gray-600 hover:text-[var(--color-primary-500)] transition-colors duration-300">{t('footer.bottom_sitemap')}</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
